/**
 * The configuration file for the package-json-config.ts file upgrading to Angular 15.
 */
export const replaces = {
    '"@msft-sme/core": "2.633.0"': '"@msft-sme/core": "4.99.0"',
    '"@msft-sme/angular": "2.633.0"': '"@msft-sme/angular": "4.99.0"',
    '"@msft-sme/styles": "2.633.0"': '"@msft-sme/styles": "4.99.0"',
    '"@microsoft/windows-admin-center-sdk/tools": "2.633.0"': '"@microsoft/windows-admin-center-sdk/tools": "4.99.0"',
    '"@msft-sme/file-explorer": "2.174.0"': '"@msft-sme/file-explorer": "4.10.0"',
    '"@msft-sme/remote-desktop": "2.35.0"': '"@msft-sme/remote-desktop": "4.9.0"',
    '"@msft-sme/event-viewer": "2.88.0"': '"@msft-sme/event-viewer": "4.8.0"',
    '"@msft-sme/azure-center": "2.47.0"': '"@msft-sme/azure-center": "4.9.0"',
    '"@msft-sme/storage": "2.44.0"': '"@msft-sme/storage": "4.8.0"',
    '"@msft-sme/local-users-groups": "2.45.0"': '"@msft-sme/local-users-groups": "4.7.0"',
    '"@msft-sme/powershell-console": "2.33.0"': '"@msft-sme/powershell-console": "4.8.0"'
}

export const replacesPipeline = {
    '"@angular/animations": "11.2.14"': '"@angular/animations": "15.2.9"',
    '"@angular/common": "11.2.14"': '"@angular/common": "15.2.9"',
    '"@angular/compiler": "11.2.14"': '"@angular/compiler": "15.2.9"',
    '"@angular/core": "11.2.14"': '"@angular/core": "15.2.9"',
    '"@angular/forms": "11.2.14"': '"@angular/forms": "15.2.9"',
    '"@angular/language-service": "11.2.14"': '"@angular/language-service": "15.2.9"',
    '"@angular/platform-browser": "11.2.14"': '"@angular/platform-browser": "15.2.9"',
    '"@angular/platform-browser-dynamic": "11.2.14"': '"@angular/platform-browser-dynamic": "15.2.9"',
    '"@angular/router": "11.2.14"': '"@angular/router": "15.2.9"',
    '"core-js": "2.6.2"': '"core-js": "3.30.1"',
    '"tslib": "^2.0.0"': '"tslib": "^2.3.0"',
    '"rxjs": "6.6.0"': '"rxjs": "~7.5.0"',
    '"zone.js": "0.11.3"': '"zone.js": "0.13.1"',
    '"@angular-builders/custom-webpack": "11.1.1"': '"@angular-builders/custom-webpack": "15.0.0"',
    '"@angular-devkit/build-angular": "0.1102.13"': '"@angular-devkit/build-angular": "15.2.9"',
    '"@angular-eslint/builder": "4.3.1"': '"@angular-eslint/builder": "15.2.1"',
    '"@angular-eslint/eslint-plugin": "4.3.1"': '"@angular-eslint/eslint-plugin": "15.2.1"',
    '"@angular-eslint/eslint-plugin-template": "4.3.1"': '"@angular-eslint/eslint-plugin-template": "15.2.1"',
    '"@angular-eslint/schematics": "4.3.1"': '"@angular-eslint/schematics": "15.2.1"',
    '"@angular-eslint/template-parser": "4.3.1"': '"@angular-eslint/template-parser": "15.2.1"',
    '"@angular/cli": "11.2.13"': '"@angular/cli": "15.2.9"',
    '"@angular/compiler-cli": "11.2.14"': '"@angular/compiler-cli": "15.2.9"',
    '"@types/jasmine": "3.6.0"': '"@types/jasmine": "~4.3.0"',
    '"@types/karma": "5.0.0"': '"@types/karma": "6.3.4"',
    '"@types/node": "12.11.1"': '"@types/node": "17.0.21"',
    '"@typescript-eslint/eslint-plugin": "4.16.1"': '"@typescript-eslint/eslint-plugin": "6.4.1"',
    '"@typescript-eslint/parser": "4.16.1"': '"@typescript-eslint/parser": "6.4.1"',
    '"eslint": "7.6.0"': '"eslint": "8.47.0"',
    '"eslint-plugin-import": "2.21.0"': '"eslint-plugin-import": "2.28.1"',
    '"eslint-plugin-jsdoc": "36.1.1"': '"eslint-plugin-jsdoc": "^46.5.0"',
    '"eslint-plugin-jsonc": "2.8.0"': '"eslint-plugin-jsonc": "^2.9.0"',
    '"gulp": "4.0.0"': '"gulp": "4.0.2"',
    '"jasmine-core": "3.6.0"': '"jasmine-core": "~4.5.0"',
    '""jasmine-reporters": "2.4.0"': '"jasmine-reporters": "~2.5.2"',
    '"karma": "6.1.0"': '"karma": "~6.4.0"',
    '"karma-coverage": "2.0.3"': '"karma-coverage": "~2.2.0"',
    '"karma-jasmine": "4.0.0"': '"karma-jasmine": "5.1.0"',
    '"karma-jasmine-html-reporter": "1.5.0"': '"karma-jasmine-html-reporter": "2.1.0"',
    '"karma-typescript": "5.5.1"': '"karma-typescript": "5.5.4"',
    '"ng-mocks": "11.10.1"': '"ng-mocks": "~14.11.0"',
    '"ng-packagr": "11.2.4"': '"ng-packagr": "~15.2.2"',
    '"puppeteer": "10.0.0"': '"puppeteer": "~21.0.1"',
    '"selenium-webdriver": "3.6.0"': '"selenium-webdriver": "4.11.1"',
    '"ts-helpers": "1.1.1"': '"ts-helpers": "1.1.2"',
    '"ts-node": "8.3.0"': '"ts-node": "~10.9.1"',
    '"typescript": "4.1.5"': '"typescript": "4.8.2"',
    '"gulp-eslint": "6.0.0"': '"gulp-eslint-new": "1.8.3"',
    '"ajv": "6.12.6"': '"ajv": "6.12.6"',
    '"@playwright/test": "1.20.1"': '"@playwright/test": "1.31.0"'
}

// wac-uta will be brought back until we fix the dependency issue.
export const removes = [
    "@angular-devkit/build-ng-packagr",
    "@angular-devkit/build-optimizer",
    "@wac-uta/shell",
    "@wac-uta/ui-test-automation",
    "@wac-uta/file-explorer",
    "@msft-sme/ui-test-automation",
    "jquery",
    "tsickle",
    "@msft-sme/e2e"
]

export const adds = {
    '"eslint-plugin-angular": "^4.1.0"': '"eslint-plugin-deprecation": "1.5.0"',
    '"eslint-plugin-prefer-arrow": "^1.2.3"': '"eslint-plugin-unused-imports": "^3.0.0"'
}
